<template>
  <section class="page-dashboard">
    <sidebar :menu="menu.listMenu" />
    <router-view></router-view>
  </section>
</template>

<script>
import sidebar from "cp/dashboard-component/sidebar.vue";
export default {
  name: "page-dashboard",
  components: {
    sidebar
  },
  data() {
    return {
      Instructor: false,
      isInstructor: false,
      isMenu: "",
      close: true
    };
  },
  computed: {
    sidebar() {
      return this.$store.state.dashboardSidebar;
    },
    level() {
      return this.$store.state.auth.level;
    },
    menu() {
      if (this.level) {
        if (this.isInstructor) {
          return {
            isMenu: "menuInstructorSuperUser",
            listMenu: this.$store.state.dashboardSidebar.menuInstructorSuperUser
          };
        } else {
          return {
            isMenu: "menuSuperuser",
            listMenu: this.$store.state.dashboardSidebar.menuSuperuser
          };
        }
      } else {
        if (this.isInstructor) {
          return {
            isMenu: "menuInstructor",
            listMenu: this.$store.state.dashboardSidebar.menuInstructor
          };
        } else {
          return {
            isMenu: "menuUser",
            listMenu: this.$store.state.dashboardSidebar.menuUserV1
          }; 
        }
      }
    }
  },
  mounted() {
    this.getLevel();
    this.hasInstractor();
  },
  watch: {
    // patch(val){
    //   if(val){
    //     this.collapsed = tt
    //   }
    // }
  },
  methods: {
    onItemClick(e, item) {
      console.log(item);
      this.close = true;
    },
    async hasInstractor() {
      this.isInstructor = await this.checkInstructor();
    },
    async checkAccessInstructor() {
      try {
        let { data } = await axios.post("/become-instructor/check");
        if (data.state !== 200) return;
        this.Instructor = data["is-instrustor"];
      } catch (error) {
        console.log(error);
      }
    },
    async getLevel() {
      try {
        let { data } = await axios.post("/users/get-level");
        // localStorage.setItem('level', data.level)
        this.$store.commit("auth/setLevel", data.level);
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
<style lang="less">
@media screen and (max-width: 992px) {
  .page-dashboard {
    padding-top: 50px;
    padding-right: 60px;
  }
}
.v-sidebar-menu {
  padding-bottom: 0 !important;
  padding-top: 110px !important;
  .vsm-arrow:after {
    content: "\F136" !important;
    font-family: Flaticon !important;
  }
  .collapse-btn {
    &:after {
      //  content: "\f172" !important;
      content: "\f173" !important;
      font-family: Flaticon !important;
    }
  }
}

.vsm-collapsed {
  .collapse-btn {
    &:after {
      content: "\f172" !important;
      // content: "\f173" !important;
      font-family: Flaticon !important;
    }
  }
}
.v-sidebar-menu.white-theme
  .vsm-item.first-item.active-item
  > .vsm-link
  > .vsm-icon,
.v-sidebar-menu.white-theme
  .vsm-item.first-item.parent-active-item
  > .vsm-link
  > .vsm-icon {
  background-color: var(--green) !important;
}
.v-sidebar-menu > .vsm-list {
  overflow: auto !important;
}
.v-sidebar-menu .collapse-btn {
  bottom: auto !important;
  top: 60px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/dashboard.vue